import UpdateCustomInboxesEvent from './UpdateCustomInboxesEvent';

const CustomInboxEvents = {
  UpdateCustomInboxes: UpdateCustomInboxesEvent,
};

export default CustomInboxEvents;
